import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Hero } from '../components/Hero';
import { Form } from '../components/Form';

import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

export const CreditLimitMastercard = ({hibisId}) => {

  return (
    <>
      <Header />
      <Hero image="oskar-mastercard2.jpg" xPos="56%" yPos="18%" />
      <div className="addiko-app">
        <Container>
            <Row>
                <Col md={6} className="p-3">
                    <h1>Pozabite na skrbi ob skoraj izkoriščenem limitu!</h1>
                    <p className="text-left">
                      Kadar je limit na vaši  kartici skoraj v celoti izkoriščen, lahko hitro pride do neprijetne situacije.                      
                    </p>
                    <p className="text-left red-text">
                      To pomeni, da zaradi izkoriščenega limita kartice Mastercard morda ne boste mogli uporabiti ravno v trenutku, ko jo najbolj potrebujete. 
                    </p>
                    <p className="text-left">
                      Z Addiko gotovinskim kreditom  lahko izkoriščen limit na kartici poplačate in hkrati pridobite dodatna sredstva za druge načrte. <b>Izpolnite obrazec in kmalu vas bomo poklicali.</b>
                    </p>
                    <p className="text-left text-small">
                        Kjerkoli in kadarkoli, vedno z vami!<br />
                        Addiko banka
                    </p>
                </Col>
                <Col md={1} className="p-3 d-none d-md-block">
                    &nbsp;
                </Col>
                <Col md={5} className="p-3">
                  <Form guid="a247eab1-e16a-45fa-b2c9-53a7dca8f4b6" hibisId={hibisId} />
                </Col>
            </Row>
        </Container>
      </div>      
      <Footer />
    </>
  );
}